import { useRef } from 'react';
import { AllieSelect, AllieSelectProps } from '../../../components';

export interface AllieControlledSelectType extends AllieSelectProps {
  options: any[];
  initialValue: string;
  onSelect?: (e: CustomEvent) => Promise<unknown>;
}

export const AllieControlledSelect = 
  ({ initialValue, options, onSelect, ...props }: AllieControlledSelectType) => {
    const controlledSelectRef = useRef<HTMLIonSelectElement>(null);

    const onChange = (e: CustomEvent) => {
      if (onSelect && e.detail.value !== initialValue) {
        onSelect(e)
        .catch(() => {
          controlledSelectRef.current?.setAttribute('programatic', 'true');
          controlledSelectRef.current?.setAttribute('value', initialValue);
          controlledSelectRef.current?.removeAttribute('programatic');
        })
      };
    }

    return (
      <AllieSelect
        {...props}
        options={options}
        onChange={onChange}
        selected={initialValue}
        ref={controlledSelectRef}
      />
    )
  };
